import { Injectable } from '@angular/core';
import { Observable, interval, mapTo, scan, takeWhile, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountdownService {
  getSecondsCountdown$(countdownFrom: number): Observable<number> {
    return interval(1000)
      .pipe(
        mapTo(-1),
        scan((acc, curr) => acc + curr, countdownFrom),
        takeWhile(value => value >= 0),
        startWith(countdownFrom)
      );
  }
}
